const appRoutes = {
  root: '/',
  balances: '/balances',
  calendar: '/calendar',
  messageCenter: '/message-center',
  login: '/login',
  settings: '/settings',
  timesheets: '/timesheets',
  validate: '/validate',
};

export default appRoutes;
